'use client'
import { useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { projectCaseMappers } from '../../lib'
import { useGetProjectId } from '@/app/slugs'

const useHook = () => {
  const { projectId } = useGetProjectId()
  const queryKey = [queryKeys((a, m, p) => a.project.getProjectCase({ projectId }) + m.get)]
  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getProjectCase({ projectId })),
  })

  return {
    ...query,
    data: projectCaseMappers.mapProjectCase(query?.data || {}),
    queryKey,
  }
}
export default useHook
